import React from 'react';
import Icon from '../../../components/AppIcon';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts';

const PreferenceAlignmentChart = ({ data }) => {
  const calculateAlignment = () => {
    const alignmentScores = data?.map(item => {
      const diff = Math.abs(item?.partner1 - item?.partner2);
      return 100 - diff;
    });
    return (alignmentScores?.reduce((sum, score) => sum + score, 0) / alignmentScores?.length)?.toFixed(0);
  };

  return (
    <div className="bg-card border border-border rounded-lg p-4 md:p-6 shadow-therapeutic-sm">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h3 className="text-lg md:text-xl font-heading font-semibold text-foreground">
            Preference Alignment
          </h3>
          <p className="text-sm text-muted-foreground mt-1">
            Partner compatibility across preferences
          </p>
        </div>
        <div className="flex items-center gap-2 bg-primary/10 px-3 py-2 rounded-md">
          <Icon name="Users" size={18} color="var(--color-primary)" />
          <span className="text-sm font-semibold text-primary">
            {calculateAlignment()}% Aligned
          </span>
        </div>
      </div>

      <div className="w-full h-64 md:h-80" aria-label="Preference alignment bar chart">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={data}>
            <CartesianGrid strokeDasharray="3 3" stroke="var(--color-border)" />
            <XAxis 
              dataKey="preference" 
              stroke="var(--color-muted-foreground)"
              style={{ fontSize: '11px' }}
              angle={-15}
              textAnchor="end"
              height={60}
            />
            <YAxis 
              stroke="var(--color-muted-foreground)"
              style={{ fontSize: '12px' }}
              domain={[0, 100]}
            />
            <Tooltip 
              contentStyle={{
                backgroundColor: 'var(--color-card)',
                border: '1px solid var(--color-border)',
                borderRadius: '6px',
                fontSize: '12px'
              }}
            />
            <Legend 
              wrapperStyle={{ fontSize: '12px' }}
            />
            <Bar 
              dataKey="partner1" 
              fill="var(--color-primary)" 
              radius={[6, 6, 0, 0]}
              name="Partner 1"
            />
            <Bar 
              dataKey="partner2" 
              fill="var(--color-accent)" 
              radius={[6, 6, 0, 0]}
              name="Partner 2"
            />
          </BarChart>
        </ResponsiveContainer>
      </div>

      <div className="mt-4 p-3 bg-muted/30 rounded-md">
        <div className="flex items-start gap-2">
          <Icon name="Info" size={16} color="var(--color-primary)" className="mt-0.5 flex-shrink-0" />
          <p className="text-xs text-muted-foreground leading-relaxed">
            Higher alignment indicates stronger compatibility. Focus on preferences with larger gaps for relationship growth opportunities.
          </p>
        </div>
      </div>
    </div>
  );
};

export default PreferenceAlignmentChart;